import React, { useState, useEffect } from 'react';
import {
    Container,
} from '@mui/material';
import AdminMenu from '../../components/menu';
import BoFTitle from '../../components/bof-title';
import UserForm from '../../components/form/user-form';

export default function UserDetail() {
    return(
        <>
            <AdminMenu/>
            <Container maxWidth="lg" style={{ marginTop: '7rem' }}>
                <BoFTitle
                    title={"User Detail"}
                    is_main_page={false}
                />
                <UserForm
                    mode={'edit'}
                    button_title={'Save'}
                />
            </Container>
        </>
    )
}